const baseStyle = {
  maxW: 'container.xl',
  px: { base: 6, lg: 16 }
}

export default {
  baseStyle
}
